import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/category/[slug]/CategoryClientPage.tsx");
